<template style="height: 100%;">
  <div class="CommonContentSingle-gray">
    <el-container>
      <el-header>
        <el-form :inline="true" :model="from" class="demo-form-inline">
          <el-form-item :label="pageName + '搜索：'">
            <el-input v-model="group"  placeholder="请输入要搜索的内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chaxun">查询</el-button>
          </el-form-item>
        </el-form>
      </el-header>

      <el-main>
        <el-button type="primary" @click="dialogVisible = true">
          新增
        </el-button>
        <el-button type="danger" @click="deleteData" :disabled="tableData.length > 0 ? false : true">
          删除
        </el-button>
        <el-table  ref="multipleTable"  v-loading="wloadings" :data="tableData" style="width: 100%; margin-top: 10px;" :default-sort="{ prop: 'date', order: 'descending' }" @selection-change="handleSelectionChange">
          <el-table-column type="selection" min-width="5%" align="center"></el-table-column>
          <el-table-column label="序号" min-width="8%" align="left">
            <template slot-scope="scope" center>
              {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="内容" min-width="30%">
            <template slot-scope="scope">
              <span>{{ scope.row.DropKeyContent }}</span>
            </template>
          </el-table-column>
          <el-table-column label="排序" min-width="10%">
            <template slot-scope="scope">
              <span>{{ scope.row.DropKeyLineNum }}</span>
            </template>
          </el-table-column>

          <el-table-column label="创建时间" min-width="20%">
            <template slot-scope="scope">
              <span>{{ scope.row.CreatedTimeShow }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 20px; text-align: right;" @current-change="handleCurrentChange" :page-size="10" layout="total, prev, pager, next" :total="totalnumber" v-if="tableData.length > 0"></el-pagination>
      </el-main>

    </el-container>

    <el-dialog title="新增" class="vdvschtj" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
      <el-form :model="from" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="内容" prop="DropKeyContent">
          <el-input v-model="from.DropKeyContent" style="width: 60%;"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="DropKeyLineNum">
          <el-input-number v-model="from.DropKeyLineNum" :min="1" :max="100000" style="width: 60%;"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageName: '',
      keyType: '',
      group: '',
      totalnumber: 1,
      wloadings: true,
      pageIndexs: 1,
      tableData: [],
      datasz: [], //下拉框数组
      from: {
        DropKeyType: '',
        DropKeyContent: '',
        DropKeyLineNum: '',
      },
      dialogVisible: false,
      rules: {
        DropKeyType: [
          { required: true, message: '请选择下拉框主题', trigger: 'change' },
        ],
        DropKeyContent: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        DropKeyContent: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
        ],
      },
      multipleSelection: [],
    }
  },
  components: {},
  created() {
    if (this.$route.name == 'DropDownMng_WorkGroup') {
      this.pageName = '工作小组'
      this.keyType = 'WorkGroup'
      this.from.DropKeyType = this.keyType
    } else if (this.$route.name == 'DropDownMng_MaterialLabe') {
      this.pageName = '标签'
      this.keyType = 'MaterialLabe'
      this.from.DropKeyType = this.keyType
    }
    this.loading();
  },
  methods: {
    handleCurrentChange(val) {
      this.pageIndexs = val;
      this.loading(val);
    },
    loading() {
      var dataForm = {
        pageSize: 10,
        pageIndex: this.pageIndexs - 1,
        DropKeyType: this.keyType,
      }
      this.$Http_Post('SystemSetting/GetDropDownKeyList', dataForm).then(
        (res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.wloadings = false
            this.tableData = res.Data
            this.totalnumber = res.Counts
          } else {
            this.wloadings = false
          }
        },
      )
    },
    chaxun() {
      this.loading(1);
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
      .then((_) => {
        done()
      })
      .catch((_) => {})
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$Http_Post('SystemSetting/AddDropDownKey', this.from).then(
            (res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.loading(1);
                this.Global.request_successful(res.Message);
                this.dialogVisible = false;
              } else { 
                this.Global.request_failure(res.Message);
              }
            },
          )
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = [];
      if (val.length > 0) {
        for (let i = 0; i < val.length; i++) {
          this.multipleSelection.push(val[i].DropKeyID);
        }
      }
    },
    deleteData() {
      let _this = this;
      if (_this.multipleSelection.length > 0) {
        this.$confirm('数据删除后将无法恢复，您确认删除吗？')
        .then((_) => {
          this.$Http_Post('SystemSetting/DeleteDropDownKeyList',
            _this.multipleSelection,
          ).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              _this.loading();
              this.Global.request_successful(res.Message);
            }
          })
        })
        .catch((_) => {})
      } else this.Global.request_info('请选择要删除的记录!');
    },
  },
  watch: {
    //监听
    $route(){
      if (this.$route.name == 'DropDownMng_WorkGroup'){
        this.pageName = '工作小组'
        this.keyType = 'WorkGroup'
        this.from.DropKeyType = this.keyType
      }else if(this.$route.name == 'DropDownMng_MaterialLabe'){
        this.pageName = '标签'
        this.keyType = 'MaterialLabe'
        this.from.DropKeyType = this.keyType
      }
      this.loading();
    },
  },
}
</script>
<style>

</style>
